// extracted by mini-css-extract-plugin
export default {"traffic_light_container":"traffic-light_traffic_light_container__s5ytA"};